import {createDynamicShape} from '../creators';
import {createMoveToTween} from '../tweens';
import * as THREE from 'three';
import {Vector3} from 'three';
import {Material} from "three/src/materials/Material";

class ElectricityEffect {
    private scene: any;
    private count: number;
    private mod: number;
    private MAX_POINTS: number;
    private geometry: any;
    private material: any;
    private dynamicShapes: Array<any>;

    constructor(scene: any) {
        this.scene = scene;
        this.count = 0;
        this.mod = 10;
        this.dynamicShapes = [];

        // geometry
        const geometry = new THREE.BufferGeometry();

        // attributes
        this.MAX_POINTS = 100
        const positions = new Float32Array(this.MAX_POINTS * 3); // 3 vertices per point
        geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
        this.geometry = geometry;

        // material
        this.material = new THREE.LineBasicMaterial({color: 0xff0000});
    }

    run() {
        this.addDynamicShape();
    }

    async init() {

    }

    addDynamicShape() {

        const duration = 1000 + Math.random() * 9000
        const dynamicShape = createDynamicShape(this.geometry, this.material, this.MAX_POINTS);

        (window as any).dyn = dynamicShape;

        dynamicShape.position.set(0, 0, -555);
        dynamicShape.rotation.x = 1;
        dynamicShape.rotation.y = 4;
        dynamicShape.rotation.z = 2;
        this.dynamicShapes.push(dynamicShape);
        this.scene.add(dynamicShape);

        const tween = createMoveToTween(this.scene, dynamicShape, new Vector3(0, 0, -10600), {
            duration,
        })


        tween.start().onComplete(() => {
            dynamicShape.geometry.dispose();

            if ((dynamicShape.material as Material).dispose) {
                (dynamicShape.material as Material).dispose();
            }

            this.dynamicShapes = this.dynamicShapes.filter(g => g !== dynamicShape);
            this.scene.remove(dynamicShape);
        })

        return dynamicShape;
    }


    update() {

        let count = this.count;
        const mod = this.mod;

        count = (count + 1) % mod;

        this.dynamicShapes.forEach(ds => {
            ds.geometry.setDrawRange(0, count);
            if (count === 0) {
                ds.updatePositions();
            }
        })
    }

}

export default ElectricityEffect;
